var _path, _path2, _g, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9057 10.622C14.599 10.622 14.3315 10.3962 14.2874 10.0837C14.2399 9.74121 14.4774 9.42538 14.8199 9.37788C15.6865 9.25621 16.3407 8.50455 16.3424 7.62788C16.3424 6.75871 15.719 6.02371 14.8599 5.88288C14.5199 5.82705 14.289 5.50538 14.3449 5.16455C14.4015 4.82371 14.7207 4.59538 15.0632 4.64955C16.5282 4.89038 17.5924 6.14371 17.5924 7.62955C17.589 9.12538 16.4715 10.4087 14.9924 10.6162C14.9632 10.6204 14.934 10.622 14.9057 10.622Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8578_48729",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 12,
    width: 4,
    height: 4
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8151 12.1685H18.9768V15.9431H15.8151V12.1685Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8578_48729)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3845 15.9431C17.1328 15.9431 16.8953 15.7898 16.8004 15.5406C16.677 15.2181 16.8395 14.8564 17.162 14.7339C17.727 14.5189 17.727 14.2814 17.727 14.1673C17.727 13.8023 17.2628 13.5473 16.3479 13.4106C16.007 13.3589 15.7712 13.0414 15.822 12.6989C15.8729 12.3573 16.1895 12.1298 16.5337 12.1739C18.5528 12.4764 18.977 13.4248 18.977 14.1673C18.977 14.6206 18.7987 15.4481 17.607 15.9023C17.5337 15.9298 17.4587 15.9431 17.3845 15.9431Z",
    fill: "currentColor"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90559 13.7617C7.92559 13.7617 5.56476 14.0051 5.56476 15.1634C5.56476 16.3309 7.92559 16.5759 9.90559 16.5759C11.8856 16.5759 14.2456 16.3334 14.2456 15.1776C14.2456 14.0076 11.8856 13.7617 9.90559 13.7617ZM9.90559 17.8259C8.52309 17.8259 4.31476 17.8259 4.31476 15.1634C4.31476 12.5117 8.52309 12.5117 9.90559 12.5117C11.2881 12.5117 15.4956 12.5117 15.4956 15.1776C15.4956 17.8259 11.4348 17.8259 9.90559 17.8259Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90558 5.0835C8.49558 5.0835 7.34891 6.231 7.34891 7.641C7.34641 8.32433 7.60808 8.9635 8.08725 9.446C8.56641 9.9285 9.20475 10.196 9.88475 10.1985L9.90558 10.8235V10.1985C11.3156 10.1985 12.4631 9.05183 12.4631 7.641C12.4631 6.231 11.3156 5.0835 9.90558 5.0835ZM9.90558 11.4485H9.88308C8.86641 11.4452 7.91391 11.0468 7.20058 10.3268C6.48558 9.60766 6.09474 8.65266 6.09891 7.6385C6.09891 5.54183 7.80641 3.8335 9.90558 3.8335C12.0056 3.8335 13.7131 5.54183 13.7131 7.641C13.7131 9.74016 12.0056 11.4485 9.90558 11.4485Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90477 10.6222C4.87643 10.6222 4.84727 10.6205 4.8181 10.6164C3.33893 10.4089 2.22227 9.12554 2.21893 7.63137C2.21893 6.14387 3.2831 4.89054 4.7481 4.6497C5.09893 4.5947 5.40977 4.82554 5.46643 5.1647C5.52227 5.50554 5.29143 5.8272 4.95143 5.88304C4.09227 6.02387 3.46893 6.75887 3.46893 7.6297C3.4706 8.5047 4.12477 9.2572 4.9906 9.37804C5.3331 9.42554 5.5706 9.74137 5.5231 10.0839C5.47893 10.3964 5.21143 10.6222 4.90477 10.6222Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.42677 15.9429C2.3526 15.9429 2.2776 15.9296 2.20427 15.9021C1.01177 15.4471 0.833435 14.6196 0.833435 14.1671C0.833435 13.4254 1.2576 12.4763 3.2776 12.1738C3.62177 12.1304 3.93677 12.3571 3.98844 12.6988C4.03927 13.0413 3.80344 13.3588 3.4626 13.4104C2.5476 13.5471 2.08344 13.8021 2.08344 14.1671C2.08344 14.2813 2.08344 14.5179 2.64927 14.7338C2.97177 14.8563 3.13427 15.2179 3.01094 15.5404C2.91594 15.7896 2.67844 15.9429 2.42677 15.9429Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.b41464db0640aa66c656f664de37faf2.svg";
export { ForwardRef as ReactComponent };